
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/app/login",
      function () {
        return require("private-next-pages/app/login/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/app/login"])
      });
    }
  